"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoCall/Feedback/RatingMeter/MeterItem.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);










const MeterItem = ({
  idx, isActive, isSubmitted, className, onRatingUpdate, onRatingSubmit,
}) => {
  const handleRatingUpdate = () => onRatingUpdate(idx + 1)
  const handleRatingSubmit = () => {
    if (isSubmitted) return
    handleRatingUpdate()
    onRatingSubmit(idx + 1)
  }

  const rootClassName = _classBuilder2.default.call(void 0, 
    className,
    { active: isActive, disabled: isSubmitted },
  )

  return (
    _react2.default.createElement('div', {
      className: rootClassName,
      onMouseOver: handleRatingUpdate,
      onTouchEnd: handleRatingSubmit, __self: this, __source: {fileName: _jsxFileName, lineNumber: 29}}
    )
  )
}

exports. default = MeterItem
